/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

export const HEADER_HEIGHT = 30;
export const HEADER_PADDING = 5;

export enum GroupField {
  Title = 'title',
  Color = 'color',
}
